var path = 'components/copy-button.tpl.html';
var html = " <md-button ng-if=!isCopied class=md-icon-button tk-no-animate ngclipboard data-clipboard-text={{copyText}} ngclipboard-success=onTextCopied()> <md-tooltip md-direction=top> {{'action.copy' | translate}} </md-tooltip> <md-icon aria-label=\"{{ 'action.copy' | translate }}\" class=material-icons>content_copy</md-icon> </md-button> <md-button ng-if=isCopied class=md-icon-button ng-mouseleave=clearCopy() tk-no-animate> <md-tooltip md-direction=top> {{'action.copied' | translate}} </md-tooltip> <md-icon aria-label=\"{{ 'action.copied' | translate }}\" class=material-icons>content_copy</md-icon> </md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/copy-button.tpl.html
// module id = 1473
// module chunks = 1